/* eslint-disable no-unused-vars */
import NotificationApi from '@/api/notificationApi'
const notif_api = new NotificationApi()
import { i18n } from 'plugins/i18n.js'
import { functionRandom } from 'mixins'
import lodash from 'lodash'
import Vue from 'vue'

// mutations
const LOADING_DATA_SET = 'LOADING_DATA_SET'
const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'
const NOTIFICATIONS_DATA_SET = 'NOTIFICATIONS_DATA_SET'
const LAST_NOTIFICATIONS_DATA_SET = 'LAST_NOTIFICATIONS_DATA_SET'
const NOTIFICATIONS_CHANGE_STATE = 'NOTIFICATIONS_CHANGE_STATE'
const NOTIFICATION_ENTITIES_DATA_SET = 'NOTIFICATION_ENTITIES_DATA_SET'
const ACTIVE_SIGNAL_R_SET = 'ACTIVE_SIGNAL_R_SET'

const notificationEntityTemplate = {
  entityId: null,
  entityType: null,
  properties: []
}

const entityType = ['Tender']

const notificationType = [
  'AddTenderComment',
  'AddTenderBid',
  'ChangeTenderApprovalStatus',
  'AwatingTenderConfirmation',
  'CancelTenderBid',
  'UnselectTenderBid',
  'ProlongateTender',
  'ChangeTenderStatus',
  'ChangeTenderWinner'
]
const authorType = [
  'User',
  'Robot',
  'Reminder'
]
const status = ['1','3','4','5','7','8','9','10','11','12']
const notificationState = {
  false: 'NOT_VIWED',
  true: 'VIEWED'
}

export default {
  namespaced: true,
  state: {
    loadingNotifications: false,
    //entitys: [],
    notifications: [],
    notificationEntities: [],
    subscriptions: {
      Tender: {},
      Application: {},
    },
    activeSignalR: true,
  },
  getters: {
    isActiveSignalR: (state) => state.activeSignalR,
    accessNotification: (state, getters, rootState, rootGetters) => {
      return !!rootState.config?.availableOrganizations?.length
    },
    entityType: () => entityType,
    //entitys: (state) => state.entitys,
    notifications: (state) => state.notifications,
    notificationEntities: (state) => state.notificationEntities,
    notificationType: () => notificationType,
    notificationState: () => notificationState,
    loadingNotifications: (state) => state.loadingNotifications,
    subscriptions: (state) => state.subscriptions,
  },
  actions: {
    setSubscriptions({ commit,  }, { items }) {
      commit(SET_SUBSCRIPTION, items)
    },
    setLastEvent({ commit, dispatch }, items) {
      return new Promise((resolve, reject) => {
        commit(LOADING_DATA_SET, { value: true })
        dispatch('convertNotifications', items).then(
          (lastNotifications) => {
            commit(LAST_NOTIFICATIONS_DATA_SET, lastNotifications)
            resolve(items)
          }
        )
          .finally(() => {
            commit(LOADING_DATA_SET, { value: false })
          })
      })
    },
    convertNotifications({ state, getters, rootState, dispatch }, items) {
      return new Promise((resolve) => {
        if (!items?.length) {
          resolve([])
          return
        }
        const result = []
        //Vue.prototype.$store.getters.
        let subscription
        const subscriptions = Object.values(state.subscriptions.Tender)

        items.forEach((item) => {
          subscription = Vue.prototype.$_.cloneDeep(subscriptions.find(i => i.subscriptionEntityId === item.subscriptionEntityId)) || {}

          item.entity = subscription?.entity || {}
          item.entity.properties = subscription?.properties || subscription?.entity?.properties || []
          item.message.date = new Date(item.message.timestamp)
          item.message.dateText = `${i18n.d(item.message.date, 'shortDate')}, ${i18n.d(item.message.date, 'time')}`

          if (item.entity && item.entity.properties) {
            item.entity.properties.forEach((prop) => {
              item.entity[prop.key] = prop.value
            })
          }
          if (item?.entity?.organizationItId) {
            let entityOrg = rootState.config.availableOrganizations?.find(i => i.organizationItId === item.subscription.entity.organizationItId)
            let entityOrgTitle
            if (entityOrg) {
              entityOrgTitle = entityOrg?.titleWithoutOkpo.replaceAll('"', '').replaceAll('(', '').replaceAll(')', '')
            }
            item.entity.entityOrgTitle = entityOrgTitle
          }
          item.entity.dateSend = item.message.dateText
          item.message.entity = item.entity

          if (item.message && item.message.properties) {
            item.message.properties.forEach((prop) => {
              item.message[prop.key] = prop.value
            })
          }


          if (item.message.AuthorType === 'Robot') {
            item.message.Author = i18n.t('StopLists.Authomatically')
          } else if (item.message.AuthorType === 'Reminder') {
            item.message.Author = 'Нагадування'
          } else {
            item.message.Author = item.message.Author || i18n.t('StopLists.Authomatically')
          }

          delete item.subscription

          result.push(item)
        })
        resolve(result)
      })
    },
    changeState({ commit, getters, rootState }, items) {
      return new Promise((resolve, reject) => {
        commit(NOTIFICATIONS_CHANGE_STATE, items)
      })
    },
    addNotifications({ commit, dispatch }, items) {
      return new Promise((resolve) => {
        if (!items?.length) {
          resolve([])
          return
        }

        dispatch('convertNotifications', items).then(
          (response) => {
            commit(LAST_NOTIFICATIONS_DATA_SET, response)
            resolve(response)
          }
        )
      })
    },
    changeActiveSignalR({ commit, getters, rootState }, value) {
      return new Promise((resolve, reject) => {
        commit(ACTIVE_SIGNAL_R_SET, value)
      })
    },
  },
  mutations: {
    [LOADING_DATA_SET](state, { value }) {
      //state.loadingNotifications = value
    },
    [LAST_NOTIFICATIONS_DATA_SET](state, value) {
      let oldNotifications = []
      const lastMessageId = value.map(i => i.message.messageId)

      if (lastMessageId && state.notifications?.length) {
        oldNotifications = lodash.cloneDeep(state.notifications).filter(i => !lastMessageId.includes(i.message.messageId))
      }

      state.notifications = value.concat(oldNotifications)
    },
    [NOTIFICATIONS_DATA_SET](state, value) {
      state.notifications = value
    },
    [NOTIFICATION_ENTITIES_DATA_SET](state, value) {
      state.notificationEntities = value
    },
    [NOTIFICATIONS_CHANGE_STATE](state, entities) {
      entities?.forEach((subscribleEntitie) => {
        subscribleEntitie.messages?.forEach((subscribleMessage) => {
          const notifications = state.notifications.find(i => i.subscriptionEntityId === subscribleEntitie.subscriptionEntityId && i.message.messageId === subscribleMessage.messageId)
          if (notifications) { notifications.message.viewed = !notifications.message.viewed }
        })
      })
    },
    [SET_SUBSCRIPTION](state, items) {
      if (items?.length) {
        items.forEach((item) => {
          if (!item || !item.entity) {
            return
          }
          if (item.unsubscribed) {
            Vue.delete(state.subscriptions[item.entity.entityType], item.entity.entityId)
          } else {
            Vue.set(state.subscriptions[item.entity.entityType], [item.entity.entityId], item)
          }
        })
      }
    },
    [ACTIVE_SIGNAL_R_SET](state, value) {
      if (state.activeSignalR !== value) {
        state.activeSignalR = value
      }
    },
  }
}
